export const SKILL_STATEMENT_EVENT_NAMES = {
  CLICKED_ADD: 'Clicked Add Present Level Statement',
  CLICKED_EDIT: 'Clicked Edit Present Level Statement',
  CLICKED_CLOSE: 'Clicked Close Present Level Statement',
  CLICKED_DELETE: 'Clicked Delete Present Level Statement',
  CLICKED_LEVEL: 'Clicked Statement Level'
}

export const GOAL_RECOMMENDATION_EVENT_NAMES = {
  CLICKED_GOAL_SHORTCUT: 'Clicked Present Levels Goal Shortcut',
  OPENED_AI_DISCLAIMER: 'Opened AI Disclaimer Modal'
}

export const RESULTS_EVENT_NAMES = {
  CLICKED_SELECT_NEXT_SUBJECT: 'Clicked Select Next Subject Statements',
  CLICKED_GENERATE_DRAFT: 'Clicked Generate Draft Present Levels'
}

export const CONCLUSION_EVENT_NAMES = {
  CLICKED_STATEMENT_TAB: 'Clicked Present Levels Conclusion Statement',
  CLICKED_ASSESSMENTS_TAB: 'Clicked Aligned Assessments',
  CLICKED_GOALS_TAB: 'Clicked Goals & Strategies',
  CLICKED_COPY_STATEMENT: 'Clicked Copy Statement from Drafted',
  CLICKED_EDIT_STATEMENTS: 'Clicked Edit Statements from Drafted'
}

export const WIZARD_EVENT_NAMES = {
  VIEWED: 'Viewed Present Levels Wizard',
  VIEWED_DRAFTED: 'Viewed Drafted Present Levels',
  CLICKED_BROWSE_ASSESSMENTS: 'Clicked Browse Assessments from Present Levels',
  CLICKED_DEVELOP: 'Clicked Develop Present Levels'
}
